"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const lodash_1 = require("lodash");
const react_bootstrap_1 = require("react-bootstrap");
const NestedEditComponent_1 = require("./NestedEditComponent");
const ReactDOM = require("react-dom");
let ModalComponent = class ModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.getRepField = () => {
            const repField = this.props.constants.fields.find((field) => field.representative);
            if (!repField) {
                console.error("Did you forget to add the representative tag at the top level.");
            }
            return repField;
        };
        this.createOrEditSuccess = (data) => {
            this.setState({
                requestInProgress: false
            });
            this.props.createOrEditSuccess();
        };
        this.createOrEditError = (err) => {
            this.setState(Object.assign({}, this.state, { error: err, requestInProgress: false }));
            this.closeDeleteModal();
            this.modalBodyRef.scrollTop = 0;
        };
        this.closeModal = () => {
            this.setState(Object.assign({}, this.state, lodash_1.omit(this.state, "error")));
            this.props.closeModal();
        };
        this.modelChanged = (value) => {
            this.setState((prevState) => {
                return { item: Object.assign({}, prevState.item, value) };
            });
        };
        this.openDeleteModal = () => {
            this.setState(Object.assign({}, this.state, { deleteModal: true }));
        };
        this.closeDeleteModal = () => {
            this.setState(Object.assign({}, this.state, { deleteModal: false }));
        };
        this.deleteModel = () => {
            this.props.deleteModel(this.props.constants.modelName, this.state.item, this.createOrEditSuccess, this.createOrEditError, this.props.queryParams);
        };
        this.state = {
            item: this.props.item || {},
            deleteModal: false
        };
    }
    getInitialState() {
        return {
            item: this.props.modalType === "CREATE" ? {} : this.props.item,
            deleteModal: false
        };
    }
    modalPerformOperation(modalType, edit) {
        return () => {
            this.setState({
                requestInProgress: true
            });
            if (modalType === "FILTER") {
                const newItem = Object.assign({}, this.state.item, { skip: 0, paginate: Object.assign({}, this.state.item.paginate, { currentPage: 1 }) });
                // Copies the filter items to persist the preference
                Object.assign(this.props.item, newItem);
                this.props.filter(this.props.constants.modelName, newItem, this.filterSuccess, this.filterError, this.props.queryParams);
            }
            else if (modalType === "CREATE" || modalType === "EDIT" || modalType === "CUSTOM") {
                this.props.createOrModify(this.props.constants.modelName, this.state.item, edit, this.createOrEditSuccess, this.createOrEditError, this.props.queryParams);
            }
        };
    }
    filterSuccess(data) {
        this.setState({
            requestInProgress: false
        });
        this.props.filterSuccess();
    }
    filterError(err) {
        this.setState(Object.assign({}, this.state, { error: err, requestInProgress: false }));
    }
    render() {
        let errorType, errorMessage;
        if (this.state.error && !lodash_1.isEmpty(this.state.error.message)) {
            try {
                const error = JSON.parse(this.state.error.message);
                errorType = error.type;
                errorMessage = error.message || error.error.message;
            }
            catch (error) {
                errorMessage = this.state.error.message;
            }
        }
        const { requestInProgress } = this.state;
        const errorClassName = this.state.error ? "error-animate" : "";
        return React.createElement(react_bootstrap_1.Modal, { show: this.props.showModal, onHide: this.closeModal, container: this, "aria-labelledby": "contained-modal-title", backdrop: this.props.constants.disableModalOutsideClick ? "static" : true, dialogClassName: this.props.constants.largeEdit ? `${errorClassName} large-modal` : `${errorClassName}` },
            React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                this.props.modalType === "CREATE" &&
                    React.createElement(react_bootstrap_1.Modal.Title, { id: "contained-modal-title" }, "+ New " + this.props.constants.creationTitle),
                this.props.modalType === "EDIT" && React.createElement(react_bootstrap_1.Modal.Title, { id: "contained-modal-title" }, "Edit " + this.props.constants.creationTitle + " - " + this.props.item[this.getRepField().field]),
                this.props.modalType === "FILTER" &&
                    React.createElement(react_bootstrap_1.Modal.Title, { id: "contained-modal-title" }, "Filter " + this.props.constants.creationTitle),
                this.props.modalType === "CUSTOM" &&
                    React.createElement(react_bootstrap_1.Modal.Title, { id: "contained-modal-title" }, "Custom " + this.props.constants.creationTitle + " - " + this.props.item[this.getRepField().field])),
            React.createElement(react_bootstrap_1.Modal.Body, { ref: reactComponent => this.modalBodyRef = ReactDOM.findDOMNode(reactComponent), className: "modal-height" },
                this.state.error &&
                    React.createElement(react_bootstrap_1.Alert, { bsStyle: "danger" }, React.createElement("div", null,
                        errorType && React.createElement("b", null, errorType),
                        errorMessage && React.createElement("div", null, errorMessage))),
                React.createElement(NestedEditComponent_1.NestedEditComponent, { field: this.props.constants, modalType: this.props.modalType, readonly: this.props.modalType !== "CREATE" && this.props.constants.readonly === true, additionalModels: this.props.additionalModels, fetch: this.props.fetch, modelChanged: this.modelChanged, currentModel: this.state.item, additionalProps: this.props.additionalProps, showTitle: false, parentModel: {} })),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                this.props.deleteModel && this.props.modalType === "EDIT" &&
                    React.createElement("div", { className: "btn btn-danger", style: { float: "left" }, onClick: this.openDeleteModal }, "Delete"),
                this.state.deleteModal &&
                    React.createElement(react_bootstrap_1.Modal, { show: this.state.deleteModal, onHide: this.closeDeleteModal, container: this },
                        React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, "Delete " + this.props.constants.creationTitle),
                        React.createElement(react_bootstrap_1.Modal.Body, null, "Are you sure you want to delete " + this.props.item[this.getRepField().field] + " ?"),
                        React.createElement(react_bootstrap_1.Modal.Footer, null,
                            React.createElement("div", { className: "btn btn-danger", onClick: this.deleteModel }, "Delete"),
                            React.createElement("div", { className: "btn btn-secondary", onClick: this.closeDeleteModal }, "Cancel"))),
                this.props.modalType === "EDIT" ?
                    React.createElement(React.Fragment, null,
                        React.createElement("button", { disabled: requestInProgress, className: "btn btn-primary", onClick: this.modalPerformOperation(this.props.modalType, true) }, "Update"),
                        this.props.constants.saveAsNew &&
                            React.createElement("button", { disabled: requestInProgress, className: "btn btn-primary", onClick: this.modalPerformOperation(this.props.modalType, false) }, "Save as New")) : null,
                this.props.modalType === "CREATE" || this.props.modalType === "CUSTOM" ? (React.createElement("button", { disabled: requestInProgress, className: "btn btn-primary", onClick: this.modalPerformOperation(this.props.modalType, false) }, this.props.successButtonLabel || "Create")) : null,
                this.props.modalType === "FILTER" ? (React.createElement("button", { disabled: requestInProgress, className: "btn btn-primary", onClick: this.modalPerformOperation(this.props.modalType, false) }, "Filter")) : null,
                React.createElement("button", { disabled: requestInProgress, className: "btn btn-secondary", onClick: this.closeModal }, "Cancel")));
    }
};
ModalComponent = __decorate([
    autobind_decorator_1.default
], ModalComponent);
exports.ModalComponent = ModalComponent;
//# sourceMappingURL=ModalComponent.js.map